// extracted by mini-css-extract-plugin
export var addButton = "_5u-d";
export var bullets = "_5u-e";
export var compact = "_5u-2";
export var container = "_5u-j";
export var extendedWarrantyModal = "_5u-f";
export var learn = "_5u-l";
export var learnMore = "_5u-g";
export var offeringOption = "_5u-3";
export var offeringPrice = "_5u-8";
export var offeringSubtitle = "_5u-7";
export var offeringTitle = "_5u-6";
export var offeringsContainer = "_5u-0";
export var pdpTilesBackground = "_5u-n";
export var plan = "_5u-m";
export var regular = "_5u-1";
export var remove = "_5u-k";
export var seeDetailsIcon = "_5u-i";
export var seeDetailsLink = "_5u-h";
export var selectedOption = "_5u-4";
export var shieldIcon = "_5u-b";
export var shieldIconCompact = "_5u-c";
export var subtitle = "_5u-a";
export var title = "_5u-9";
export var unselectedOption = "_5u-5";